/**
 * Retrieves a value from a nested object using a dot-notation path.
 *
 * @param obj - The object to retrieve the value from
 * @param path - A dot-notation path string (e.g. "attributes.entityMetadata.name")
 * @returns The value at the path, or undefined if any segment is missing
 */
export const getValueAtPath = (obj: unknown, path: string): unknown => {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc: unknown, segment: string) => {
    if (acc === undefined || acc === null) return undefined;
    return (acc as Record<string, unknown>)[segment];
  }, obj);
};
